import { Injectable } from "@nestjs/common";
import { ServiceStatusEnum } from "@gtpl/shared-models/common-models";
import { AssetTransactionDto } from "./asset-transaction-dto";
import { AssetTransaction } from "../asset-transaction-entity";

@Injectable()
export class AssetTransactionAdapter {
    public convertAssetTransactionDtoToEntity(assetsDto: AssetTransactionDto): AssetTransaction {
        const assets = new AssetTransaction();
        assets.assetTransactionId = assetsDto.assetTransactionId;
        assets.assetId = assetsDto.assetId;
        assets.assetsName = assetsDto.assetsName;
        assets.assetsCode = assetsDto.assetsCode;
        assets.assetSerialNo = assetsDto.assetSerialNo;
        assets.noOfUnits = assetsDto.noOfUnits;
        assets.insurance = assetsDto.insurance;
        assets.insuranceDate = assetsDto.insuranceDate;
        assets.amc = assetsDto.amc;
        assets.amcname = assetsDto.amcname;
        assets.amcno = assetsDto.amcno;
        assets.assetcondition = assetsDto.assetcondition;
        assets.invoice = assetsDto.invoice;
        assets.model = assetsDto.model;
        assets.year = assetsDto.year;
        assets.assetSupplier = assetsDto.assetSupplier;
        assets.expiredDate = assetsDto.expiredDate;
        assets.assetCost = assetsDto.assetCost;
        assets.dateOfPurchased = assetsDto.dateOfPurchased;
        assets.assetCategory = assetsDto.assetCategory;
        assets.status = assetsDto.status;
        assets.unitsOfMeasurements = assetsDto.unitsOfMeasurements;
        assets.grnId = assetsDto.grnId;
        assets.itemId = assetsDto.itemId;
        assets.warrenty = assetsDto.warrenty;
        assets.warrentyExpiredDate = assetsDto.warrentyExpiredDate;
        assets.ownerOfAsset = assetsDto.ownerOfAsset;
        assets.lastCheckIn = assetsDto.lastCheckIn;
        assets.lastCheckOut = assetsDto.lastCheckOut;
        assets.department = assetsDto.department;
        assets.employeeId = assetsDto.employeeId;
        assets.amcReason = assetsDto.amcReason;
        assets.maintenanceDueDate = assetsDto.maintenanceDueDate;
        assets.transactionDate = assetsDto.transactionDate;
        assets.decommissionApprovedBy = assetsDto.decommissionApprovedBy;
        assets.plant = assetsDto.plant;
        assets.isActive = assetsDto.isActive === undefined ? true : assetsDto.isActive;
        assets.assetServiceDate = assetsDto.assetServiceDate;
        assets.serviceTenure = assetsDto.serviceTenure;
        assets.serviceType = assetsDto.serviceType;
        assets.amcProvider = assetsDto.amcProvider;
        assets.frequencyOfService = assetsDto.frequencyOfService;
        assets.month = assetsDto.month;
        assets.day = assetsDto.day;
        assets.assetRentTenureType = assetsDto.assetRentTenureType;
        assets.assetRentPeriod = assetsDto.assetRentPeriod;
        assets.rentalCostType = assetsDto.rentalCostType;
        assets.rentalCost = assetsDto.rentalCost;
        assets.assetMode = assetsDto.assetMode;
        assets.assetType  = assetsDto.assetType;
        assets.insuranceRefNum = assetsDto.insuranceRefNum;
        assets.insuranceProvidedBy = assetsDto.insuranceProvidedBy;
        assets.licenseNumber = assetsDto.licenseNumber;
        assets.softAssetManufacturer = assetsDto.softAssetManufacturer;
        assets.hostingInfo = assetsDto.hostingInfo;
        assets.hostType = assetsDto.hostType;
        assets.hostAddress = assetsDto.hostAddress;
        assets.location = assetsDto.location;
        assets.domainUrl = assetsDto.domainUrl;
        assets.userName = assetsDto.userName;
        assets.password = assetsDto.password;
        assets.locationId = assetsDto.locationId;
        assets.serviceName = assetsDto.serviceName;
        assets.maintenanceCost = assetsDto.maintenanceCost;

        if (assetsDto.serviceStatus == 'OPEN') {
            assets.serviceStatus = ServiceStatusEnum.OPEN
        } else if (assetsDto.serviceStatus == 'COMPLETE') {
            assets.serviceStatus = ServiceStatusEnum.COMPLETE
        }
        return assets;
    }
    // public convertAssetTransactionEntitytoDto(assets: Assets): AssetsDto {
    //     const assetsDto = new AssetsDto;
    //     assetsDto.assetId = assets.assetId
    //     assetsDto.assetsName = assets.assetsName;
    //     assetsDto.assetsCode = assets.assetsCode;
    //     assetsDto.assetSerialNo = assets.assetSerialNo;
    //     assetsDto.noOfUnits = assets.noOfUnits;
    //     assetsDto.insurance = assets.insurance;
    //     assetsDto.insuranceDate = assets.insuranceDate;
    //     assetsDto.amc = assets.amc;
    //     assetsDto.amcname = assets.amcname;
    //     assetsDto.amcno = assets.amcno;
    //     assetsDto.assetcondition = assets.assetcondition;
    //     assetsDto.invoice = assets.invoice;
    //     assetsDto.model = assets.model;
    //     assetsDto.year = assets.year;
    //     assetsDto.assetSupplier = assets.assetSupplier;
    //     assetsDto.expiredDate = assets.expiredDate;
    //     assetsDto.assetCost = assets.assetCost;
    //     assetsDto.dateOfPurchased = assets.dateOfPurchased;
    //     assetsDto.assetCategory = assets.assetCategory;
    //     assetsDto.status = assets.status;
    //     assetsDto.unitsOfMeasurements = assets.unitsOfMeasurements;
    //     assetsDto.grnId = assets.grnId;
    //     assetsDto.itemId = assets.itemId;
    //     assetsDto.warrenty = assets.warrenty;
    //     assetsDto.warrentyExpiredDate = assets.warrentyExpiredDate;
    //     assetsDto.ownerOfAsset = assets.ownerOfAsset;
    //     assetsDto.lastCheckIn = assets.lastCheckIn;
    //     assetsDto.lastCheckOut = assets.lastCheckOut;
    //     assetsDto.department = assets.department;
    //     assetsDto.employeeId = assets.employeeId;
    //     assetsDto.amcReason = assets.amcReason;
    //     assetsDto.maintenanceDueDate = assets.maintenanceDueDate;
    //     assetsDto.transactionDate = assets.transactionDate;
    //     assetsDto.decommissionApprovedBy = assets.decommissionApprovedBy;
    //     assetsDto.plant = assets.plant;
    //     assetsDto.serviceTenure = assets.serviceTenure;
    //     assetsDto.assetServiceDate = assets.assetServiceDate;
    //     assetsDto.currentLocation = assets.assetsLocation[0]?.locationId;
    //     assetsDto.serviceStatus = assets.serviceStatus;
    //     assetsDto.serviceType = assets.serviceType;
    //     assetsDto.amcProvider = assets.amcProvider;
    //     assetsDto.frequencyOfService = assets.frequencyOfService;
    //     assetsDto.month = assets.month;
    //     assetsDto.day = assets.day;
    //     assetsDto.assetRentTenureType = assets.assetRentTenureType;
    //     assetsDto.assetRentPeriod = assets.assetRentPeriod;
    //     assetsDto.rentalCostType = assets.rentalCostType;
    //     assetsDto.rentalCost = assets.rentalCost;
    //     assetsDto.assetMode = assets.assetMode;
    //     assetsDto.assetType = assets.assetType;
    //     assetsDto.insuranceRefNum = assets.insuranceRefNum;
    //     assetsDto.insuranceProvidedBy = assets.insuranceProvidedBy;
    //     assetsDto.licenseNumber = assets.licenseNumber;
    //     assetsDto.softAssetManufacturer = assets.softAssetManufacturer;
    //     assetsDto.hostingInfo = assets.hostingInfo;
    //     assetsDto.hostType = assets.hostType;
    //     assetsDto.hostAddress = assets.hostAddress;
    //     assetsDto.location = assets.location;
    //     assetsDto.domainUrl = assets.domainUrl;
    //     assetsDto.userName = assets.userName;
    //     assetsDto.password = assets.password;
    //     // assetsDto.ownerOfAsset = assets.assetsAssignment[0]?.employeeId;

    //     return assetsDto;
    // }

    public convertAssetTransactionEntitytoDto(assets: AssetTransaction): AssetTransactionDto {
        const assetsDto = new AssetTransactionDto;
        assetsDto.assetTransactionId = assets.assetTransactionId;
        assetsDto.assetId = assets.assetId
        assetsDto.assetsName = assets.assetsName;
        assetsDto.assetsCode = assets.assetsCode;
        assetsDto.assetSerialNo = assets.assetSerialNo;
        assetsDto.noOfUnits = assets.noOfUnits;
        assetsDto.insurance = assets.insurance;
        assetsDto.insuranceDate = assets.insuranceDate;
        assetsDto.amc = assets.amc;
        assetsDto.amcname = assets.amcname;
        assetsDto.amcno = assets.amcno;
        assetsDto.assetcondition = assets.assetcondition;
        assetsDto.invoice = assets.invoice;
        assetsDto.model = assets.model;
        assetsDto.year = assets.year;
        assetsDto.assetSupplier = assets.assetSupplier;
        assetsDto.expiredDate = assets.expiredDate;
        assetsDto.assetCost = assets.assetCost;
        assetsDto.dateOfPurchased = assets.dateOfPurchased;
        assetsDto.assetCategory = assets.assetCategory;
        assetsDto.status = assets.status;
        assetsDto.unitsOfMeasurements = assets.unitsOfMeasurements;
        assetsDto.grnId = assets.grnId;
        assetsDto.itemId = assets.itemId;
        assetsDto.warrenty = assets.warrenty;
        assetsDto.warrentyExpiredDate = assets.warrentyExpiredDate;
        assetsDto.ownerOfAsset = assets.ownerOfAsset;
        assetsDto.lastCheckIn = assets.lastCheckIn;
        assetsDto.lastCheckOut = assets.lastCheckOut;
        assetsDto.department = assets.department;
        assetsDto.employeeId = assets.employeeId;
        assetsDto.amcReason = assets.amcReason;
        assetsDto.maintenanceDueDate = assets.maintenanceDueDate;
        assetsDto.transactionDate = assets.transactionDate;
        assetsDto.decommissionApprovedBy = assets.decommissionApprovedBy;
        assetsDto.plant = assets.plant;
        assetsDto.assetServiceDate = assets.assetServiceDate;
        assetsDto.serviceStatus = assets.serviceStatus;
        assetsDto.serviceType = assets.serviceType;
        assetsDto.amcProvider = assets.amcProvider;
        assetsDto.assetRentTenureType = assets.assetRentTenureType;
        assetsDto.assetRentPeriod = assets.assetRentPeriod;
        assetsDto.rentalCostType = assets.rentalCostType;
        assetsDto.rentalCost = assets.rentalCost;
        assetsDto.assetMode = assets.assetMode;
        assetsDto.assetType = assets.assetType;
        assetsDto.insuranceRefNum = assets.insuranceRefNum;
        assetsDto.insuranceProvidedBy = assets.insuranceProvidedBy;
        assetsDto.licenseNumber = assets.licenseNumber;
        assetsDto.softAssetManufacturer = assets.softAssetManufacturer;
        assetsDto.hostingInfo = assets.hostingInfo;
        assetsDto.hostType = assets.hostType;
        assetsDto.hostAddress = assets.hostAddress;
        assetsDto.location = assets.location;
        assetsDto.domainUrl = assets.domainUrl;
        assetsDto.userName = assets.userName;
        assetsDto.password = assets.password;
        assetsDto.locationId = assets.locationId;
        assetsDto.serviceName = assets.serviceName;
        assetsDto.maintenanceCost = assets.maintenanceCost;
        // assetsDto.currentLocation = assets.assetsLocation[0]?.locationId;
        // assetsDto.ownerOfAsset = assets.assetsAssignment[0]?.employeeId;

        return assetsDto;
    }
}